import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { BleConnectionLog } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, BleConnectionLog>,
    'queryKey' | 'queryFn'
  >;
}

export const useBleConnectionLogRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, BleConnectionLog>(
    [Entities.BleConnectionLogs, id],
    async () => {
      const { data } = await api.v1AdminLogsBleConnectionLogsLogIdGet(id)
      return data
    },
    { ...options },
  )
}
